import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AxiosInstance from "../Home/AxiosInstance";
import "./traineePortal.css";
import {
  dayAfterInputValue,
  todayInputValue,
  toDateInputValue,
  validateCertificationDates,
} from "./dateUtils";

const TraineeCertification = () => {
  const [certifications, setCertifications] = useState([]);
  const [certificationName, setCertificationName] = useState("");
  const [issueAuthority, setIssueAuthority] = useState("");
  const [issueDate, setIssueDate] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [certificationPath, setCertificationPath] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const traineeId = localStorage.getItem("traineeId");
  const today = todayInputValue();

  useEffect(() => {
    const fetchCertifications = async () => {
      try {
        const response = await AxiosInstance.get("companies/certifications/");
        setCertifications(response.data);
      } catch (error) {
        console.error("Error fetching certifications:", error);
      }
    };
    fetchCertifications();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    const dateError = validateCertificationDates(issueDate, expiryDate);
    if (dateError) {
      setErrorMessage(dateError);
      return;
    }

    const newCertification = {
      trainee: traineeId,
      certification: certificationName,
      issue_authority: issueAuthority,
      issue_date: toDateInputValue(issueDate),
      expiry_date: expiryDate ? toDateInputValue(expiryDate) : null,
      certificate_path: certificationPath,
    };

    try {
      const response = await AxiosInstance.post(
        "companies/certification",
        newCertification
      );

      if (response.status === 201) {
        navigate(-1);
      } else {
        setErrorMessage("Failed to create certification.");
      }
    } catch (error) {
      console.error("Error creating certification:", error);
      setErrorMessage("Failed to create certification.");
    }
  };

  const closeModal = () => {
    navigate(-1);
  };

  return (
    <div className="als-trainee-form-page">
      <div className="als-trainee-form-card">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2 className="mb-0">Add Certification</h2>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={closeModal}
          ></button>
        </div>
        <form onSubmit={handleSubmit}>
          {errorMessage && (
            <div className="alert alert-danger">{errorMessage}</div>
          )}

          <div className="mb-3">
            <label className="form-label">Certification Name</label>
            <select
              className="form-select"
              value={certificationName}
              onChange={(e) => setCertificationName(e.target.value)}
              required
            >
              <option value="">Select Certification</option>
              {certifications.map((cert) => (
                <option
                  key={cert.certification_id}
                  value={cert.certification_id}
                >
                  {cert.certification_name}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label">Issue Authority</label>
            <input
              type="text"
              className="form-control"
              value={issueAuthority}
              onChange={(e) => setIssueAuthority(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Issue Date</label>
            <input
              type="date"
              className="form-control"
              value={issueDate}
              max={today}
              onChange={(e) => {
                const next = e.target.value;
                setIssueDate(next);
                setErrorMessage("");
                if (expiryDate && next && expiryDate <= next) {
                  setExpiryDate("");
                }
              }}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Expiry Date</label>
            <input
              type="date"
              className="form-control"
              value={expiryDate}
              min={dayAfterInputValue(issueDate) || undefined}
              onChange={(e) => {
                setExpiryDate(e.target.value);
                setErrorMessage("");
              }}
            />
          </div>

          <div className="mb-4">
            <label className="form-label">Certification Path (URL)</label>
            <input
              type="url"
              className="form-control"
              value={certificationPath}
              onChange={(e) => setCertificationPath(e.target.value)}
            />
          </div>

          <div className="d-grid">
            <button type="submit" className="btn btn-primary">
              Save Certification
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TraineeCertification;
